import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-react";
import remarkGfm from "remark-gfm";
import { reactMarkdownComp } from "../../../../../Constants/reactMarkdownComp";
import { useSessionStore } from "../../../../../store/useSessionStore";
import { userType } from "../../../../types";
import { ChatRcvBotWidget } from "../ChatRcvBotWidget";
import { ChatSentBotWidget } from "../ChatSentBotWidget";
import ReasoningDisplayer from "../ReasoningDisplayer";
import InterruptComp from "../../../Interrupts";
import {
  FinalMessageContainer,
  MessagesWrapper,
  StepItem,
  StepsContainer,
} from "./style";

const MessagesComp = () => {
  const messages = useSessionStore.use.messages();
  const streaming = useSessionStore.use.streaming();
  const steps = useSessionStore.use.steps();

  return (
    <MessagesWrapper>
      {messages.map((message: any, index: number) => {
        const reasoningEnabled =
          message?.additional_kwargs?.brightagent_data?.reasoning_enabled;
        const reasoning =
          message?.additional_kwargs?.brightagent_data?.reasoning;
        return (
          <React.Fragment key={message.id || index}>
            {message?.type === userType.human && (
              <ChatSentBotWidget key={`${message.id}-sent`}>
                <ReactMarkdown
                  className="line-break"
                  children={message.content}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw] as any}
                  components={reactMarkdownComp}
                />
              </ChatSentBotWidget>
            )}
            {message?.type === userType.ai && (
              <ChatRcvBotWidget
                key={`${message.id}-rcv`}
                reasoningComp={<ReasoningDisplayer reasoning={reasoning} />}
                msgReasoningEnabled={reasoningEnabled}
              >
                <FinalMessageContainer>
                  <ReactMarkdown
                    children={message.content}
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw] as any}
                    components={reactMarkdownComp}
                  />
                </FinalMessageContainer>
              </ChatRcvBotWidget>
            )}
          </React.Fragment>
        );
      })}

      {streaming && (
        <ChatRcvBotWidget key="streaming-widget" streaming={true}>
          <div>
            <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
              BrightAgent Is Working
            </div>
            <StepsContainer>
              {steps.map((step, index) => (
                <StepItem key={`step-${index}-${step}`}>{step}</StepItem>
              ))}
            </StepsContainer>
          </div>
        </ChatRcvBotWidget>
      )}
      <InterruptComp />
    </MessagesWrapper>
  );
};

export default MessagesComp;
